import { Alert, Grid } from '@mui/material'
import { Link } from 'react-router-dom'

/**
 * Motivo pelo qual uma arma própria não contaria no Anexo E.
 * Espelha a regra do relatório do clube: arma própria só entra se estiver
 * vinculada ao acervo, controlada por SIGMA e com finalidade de atirador
 * desportivo. Retorna null quando a arma atende às regras.
 */
export const motivoForaDoAnexoE = (arma) => {
  if (!arma) return null

  if (!(Number(arma.pessoaArmaID) > 0)) {
    return 'Esta arma não está vinculada ao seu acervo.'
  }

  if (String(arma.sistemaControle) !== '1') {
    return 'Esta arma está cadastrada como SINARM. Somente armas SIGMA são aceitas no Anexo E.'
  }

  if (!arma.finalidadeID) {
    return 'Esta arma está sem finalidade cadastrada.'
  }

  if (!/(desportiv|esportiv)/i.test(arma.finalidade ?? '')) {
    return `A finalidade desta arma é "${arma.finalidade}". O Anexo E aceita somente armas com finalidade de atirador desportivo.`
  }

  return null
}

/**
 * Avisa o sócio ANTES de salvar que o lançamento não sairá no Anexo E.
 * Sem esse aviso o lançamento é gravado normalmente, aparece no histórico e
 * só é descoberto como ausente quando o clube emite o relatório.
 */
const AlertaAnexoE = ({ armaPropria, armaSelecionada }) => {
  if (!armaPropria) return null

  const motivo = motivoForaDoAnexoE(armaSelecionada)
  if (!motivo) return null

  return (
    <Grid item xs={12}>
      <Alert severity="warning" sx={{ mb: 2 }}>
        {motivo}{' '}
        <Link
          to="/acervo-pessoal"
          className="cursor-pointer font-bold underline opacity-80 hover:opacity-100 transition-colors"
        >
          Corrigir no acervo
        </Link>{' '}
        para que este lançamento conte no Anexo E.
      </Alert>
    </Grid>
  )
}

export default AlertaAnexoE
